<svg width="48px" height="65px" viewBox="0 0 68 86" version="1.1" xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Map marker</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <filter id="f3" x="0" y="0" width="200%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" dx="20" dy="20"/>
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10"/>
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal"/>
        </filter>
    </defs>
    <g id="Pin-Schule" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group">
            <circle class="shadow" id="Oval-Copy" fill="#EAEAEA" cx="34" cy="32" r="32"></circle>
            <path d="M33.3922448,65.3936555 L39.884058,81.6231884 L39.884058,81.6231884 L25.0434783,81.6231884 L31.5352914,65.3936555 C31.7404048,64.880872 32.3223753,64.6314561 32.8351588,64.8365695 C33.0892614,64.9382105 33.2906037,65.1395528 33.3922448,65.3936555 Z"
                  id="Triangle" fill="#EAEAEA" class="shadow"
                  transform="translate(2, 72.347826) scale(1, -1) translate(0, -72.347826) "></path>
            <path d="M33.3922448,65.3936555 L39.884058,81.6231884 L39.884058,81.6231884 L25.0434783,81.6231884 L31.5352914,65.3936555 C31.7404048,64.880872 32.3223753,64.6314561 32.8351588,64.8365695 C33.0892614,64.9382105 33.2906037,65.1395528 33.3922448,65.3936555 Z"
                  id="Triangle" fill="#FFFFFF" class="white selected-primary"
                  transform="translate(2, 72.347826) scale(1, -1) translate(0, -70.347826) "></path>
            <circle class="white selected-primary" id="Oval" fill="#FFFFFF" cx="34" cy="32" r="31"></circle>
        </g>
    </g>
</svg>
